import React from 'react'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion'

import { Props } from './types'

import { AccordionWrap } from './styles'

const Faq: React.FC<Props> = ({ items }): React.ReactElement => (
  <AccordionWrap>
    <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
      {items.map(item => (
        <React.Fragment key={item.key || item.question.toString()}>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>{item.question}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>{item.answer}</AccordionItemPanel>
          </AccordionItem>
        </React.Fragment>
      ))}
    </Accordion>
  </AccordionWrap>
)

export default Faq
